import React, { FC } from 'react'
import { ThemeConfig } from '@chakra-ui/theme'
import { App as WebPagesApp } from '@rw1/web-pages-launcher-ui'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import './app.css'

const WEB_PAGES_ROUTE = '/web'

interface IAppProps {
  themeConfig?: ThemeConfig
  'data-testid'?: string
}

const BrowserApp: FC<IAppProps> = () => (
  <Router>
    <Routes>
      <Route element={<WebPagesApp />} path={WEB_PAGES_ROUTE + '/*'} />
    </Routes>
  </Router>
)

export default BrowserApp
